// extracted by mini-css-extract-plugin
export default {"box":"Place_box__s+0+Z","imge":"Place_imge__-qohz","des":"Place_des__ndLVA","bydiv":"Place_bydiv__VFDVr","by":"Place_by__fwgBN","byname":"Place_byname__hEL4s"};